import { ErrorResponse } from '@apollo/client/link/error';

/**
 * Detects whether a GraphQL error from the graphqlInterface is an
 * authentication failure that should clear the session (and must not be
 * retried).
 *
 * The backend rethrows the raw `jsonwebtoken` error, so an expired token now
 * arrives as the bare message `jwt expired` rather than the older
 * `TokenExpiredError: jwt expired` form. Matching the raw message keeps the
 * auto-logout working and stops the RetryLink from hammering the request.
 */
const isAuthError = (
  graphQLErrors?: ErrorResponse['graphQLErrors'],
): boolean => {
  if (!graphQLErrors || graphQLErrors.length === 0) return false;
  const message = graphQLErrors[0].message;
  return (
    /jwt expired/i.test(message) ||
    message.includes('JsonWebTokenError') ||
    message.includes('Unable to decode JWT')
  );
};

export default isAuthError;
